import { Typography } from 'front-commons/ds';
import { DistributorStatusProps } from './interfaces';
import { DistributorLabel } from './styles';

export default function DistributorStatus({ hiddenLabel, status }: DistributorStatusProps) {
	return (
		<DistributorLabel className="hidden-in-options">
			{!hiddenLabel && (
				<Typography color="--text-primary" variant="Caption/Regular">
					{status?.label}
				</Typography>
			)}
		</DistributorLabel>
	);
}
